import React, { useState } from 'react';
import './SubjectModules.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faFileAlt, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
const getAllSubtopics = (subtopicsData) => Object.values(subtopicsData).flat();

const SEModules = () => {
  const modules = ['Module 1', 'Module 2', 'Module 3' , 'Module 4', 'Module 5'];

  const subtopicsData = {
    'Module 1': [
      { name: 'Nature of Software, Software Engineering, Software process, project, product', path: '/se-m1-s1' },
      { name: 'Process Models, Classical Evolutionary models', path: '/se-m1-s2' },
      { name: 'Agile Process - Extreme programming (XP), Principles of Agile Software Development framework, Overview of System Engineering', path: '/se-m1-s3' }
    ],
    'Module 2': [
      { name: 'Planning, Scope, Work break-down structure, Milestones, Deliverables', path: '/se-m2-s1' },
      { name: 'Cost and Estimates - (Human Resources, Time-scale, Costs)', path: '/se-m2-s2' },
      { name: 'Risk Management, RMMM Plan, Case Tools', path: '/se-m2-s3' }
    ],
    'Module 3': [
      { name: 'Software Requirements', path: '/se-m3-s1' },
      { name: 'System Modelling', path: '/se-m3-s2' }
    ],
    'Module 4': [
      { name: 'Design concepts and principles - Abstraction - Refinement - Modularity - Cohesion - Coupling', path: '/se-m4-s1' },
      { name: 'Architectural design, Detailed Design, Transaction Transformation, Refactoring of designs', path: '/se-m4-s2' },
      { name: 'Object oriented Design, User-Interface Design', path: '/se-m4-s3' }
    ],
    'Module 5': [
      { name: 'Strategic Approach to Software Testing', path: '/se-m5-s1' },
      { name: 'Cyclomatic Complexity', path: '/se-m5-s2' },
      { name: 'Regression Testing, Mutation Testing, Object Oriented Testing, Web and Mobile App Testing, DevOps, Cloud and Big Data Testing', path: '/se-m5-s3' }
    ]
  };

  const [openModule, setOpenModule] = useState(null);

  const toggleSubtopics = (module) => {
    setOpenModule(openModule === module ? null : module);
  };

  return (
    <div className="subjectbody">
      <Link to="/courses" className="return-to-course-btn">
        <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: '8px' }} />
        Back to Courses
      </Link>
      <div className="subject-header">
        <h1>Software Engineering</h1>
      </div>
      <div className="module-list">
        {modules.map((module) => (
          <div className="module" key={module}>
            <div className="module-header" onClick={() => toggleSubtopics(module)}>
              <span>{module}</span>
              <FontAwesomeIcon icon={openModule === module ? faChevronUp : faChevronDown} />
            </div>
            {openModule === module && (
              <ul className="subtopics">
                {subtopicsData[module] && subtopicsData[module].length > 0 ? (
                  subtopicsData[module].map((topic, index) => (
                    <li key={index}>
                      <span>{topic.name}</span>
                      <Link to={topic.path} className="article-link" state={{ subtopics: getAllSubtopics(subtopicsData), subjectPath: '/subject-SEModules' }}>
                        <FontAwesomeIcon icon={faFileAlt} />
                      </Link>
                    </li>
                  ))
                ) : (
                  <li>Coming Soon...</li>
                )}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SEModules;
